// extracted by mini-css-extract-plugin
export var button = "_dn-0";
export var icon = "_dn-1";